import {
    GET_DYNAMIC_LIST_SETTING_START,
    GET_DYNAMIC_LIST_SETTING_ERROR,
    GET_DYNAMIC_LIST_SETTING_SUCCESS
} from "../../constants";
import { getAllDynamicListSettings as query } from '../../lib/graphql';

const getDynamicListSettings = ({ locale }) => {
    return async (dispatch, getState, { client }) => {

        dispatch({ type: GET_DYNAMIC_LIST_SETTING_START });

        try {
            const { data } = await client.query({
                query,
                variables: { locale },
                fetchPolicy: 'network-only'
            });

            if (data?.getAllDynamicListSettings?.status == 200) {
                await dispatch({
                    type: GET_DYNAMIC_LIST_SETTING_SUCCESS,
                    payload: { dynamicListSettingsData: data?.getAllDynamicListSettings?.results }
                });
            }
        } catch (error) {
            dispatch({
                type: GET_DYNAMIC_LIST_SETTING_ERROR,
                payload: { error }
            });
        }
    }
}

export default getDynamicListSettings;